import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import devToolsPlugin from '@backstage/plugin-devtools/alpha';

/**
 * Lazily loads the custom DevTools page element. Extracted so the loader can
 * be exercised directly in unit tests.
 */
export const devToolsPageLoader = () =>
  import('./CustomDevToolsPage').then(m => <m.CustomDevToolsPage />);

/**
 * Overrides the default `/devtools` page provided by
 * `@backstage/plugin-devtools/alpha` with the custom JLL DevTools layout,
 * which adds the "Commit Info" and "Unprocessed Entities" tabs.
 *
 * The module targets `pluginId: 'devtools'` and provides a page extension
 * with no name, which resolves to the id `page:devtools` — the same id as the
 * plugin's default page. Per the new frontend system override rules, an
 * extension provided by a module with the same id as the plugin's default
 * takes precedence, so this custom page wins.
 *
 * `routeRef: devToolsPlugin.routes.root` is re-attached so the `devtools.root`
 * route remains resolvable for any extension that resolves it via
 * `useRouteRef` (e.g. the devtools nav item).
 */
export const devToolsPageModule = createFrontendModule({
  pluginId: 'devtools',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/devtools',
        loader: devToolsPageLoader,
        routeRef: devToolsPlugin.routes.root,
      },
    }),
  ],
});
